import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import axiosInstance from 'services/axios/axios';
import PersonSearch from 'components/UI/Input/PersonSearch/PersonSearch';
import PageWithBreadcrumbs from '../layouts/PageWithBreadcrumbs';
import { CSS_CLASSES } from 'components/UI/Input/PersonSearch/_constants';
import { HEADERS as TABLE_HEADERS } from 'pages/RequestFlow/RequesteeSearch/_constants';
import { OBJ_APP_BRIDGES } from 'pages/Bridges/ManagerValidation/_constants';

const SearchView = props => {
	const history = useHistory();
	const rNavDrawerOpen = useSelector(state => state?.ancillary?.drawerOpen);
	const [sLoading, setLoading] = useState(false);
	const [sErrorMessage, setErrorMessage] = useState(null);
	const [sRows, setRows] = useState([]);
	const systemName =
		history?.location?.state?.systemName ?? OBJ_APP_BRIDGES.Name;

	const arrHeaders = useMemo(() => {
		return TABLE_HEADERS.filter(
			header => header !== 'UPMC E-Sign-On ID',
		).map(header => {
			return { Value: header };
		});
	}, []);

	const onRowClickedHandler = useCallback(
		row =>
			history.push(
				`/EpicUtilities/User/${row?.payload?.Cells?.['FI_ID']?.Value}`,
				{
					systemID:
						history.location?.state?.systemID ?? OBJ_APP_BRIDGES.ID,
					systemName: systemName,
				},
			),
		[history, systemName],
	);

	const onSearchHandler = useCallback(payload => {
		setLoading(true);
		axiosInstance
			.post('api/Components/PersonSearch', payload)
			.then(response => {
				switch (response.status) {
					case 200:
						switch (response.data.responseCode) {
							case 200:
								let payload = response.data.payload;

								setRows(payload);
								setErrorMessage(null);
								break;
							default:
								setErrorMessage(
									response.data.messages[0].Value,
								);
								break;
						}
						break;
					default:
						break;
				}
			})
			.catch(error => {
				setErrorMessage(
					error && error.response && error.response.data
						? error.response.data.payload
						: error.message,
				);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	return (
		<>
			{props.isRoleAuthorized && (
				<PageWithBreadcrumbs
					currentPageLabel={`Search ${systemName} Users`}
				/>
			)}
			<Box
				sx={{
					width: rNavDrawerOpen ? '75%' : '90%',
					margin: '0 auto',
					[`> .${CSS_CLASSES.CONTAINER}`]: { margin: '0 auto' },
				}}
			>
				<PersonSearch
					errorMessage={sErrorMessage}
					label='Search Users'
					dataTable={{
						headers: arrHeaders,
						label: 'Search Results',
						onRowClickedHandler: onRowClickedHandler,
						rows: sRows,
						filtered: false,
						indexed: false,
					}}
					isLoading={sLoading}
					onButtonClickedHandler={onSearchHandler}
					requestTarget='REQUESTEE'
					shouldAutoScroll
				/>
			</Box>
		</>
	);
};

export default SearchView;
